export default __webpack_public_path__ + "static/mobile-footer-background-5876b7bf8da280cf33a4f99d301baeed.png";